import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import Pagination from "@mui/material/Pagination";
import { CircularProgress, Grid, Tooltip } from "@mui/material";
import { download_Graph } from "../../assets/images/images";
import Helper from "../../utils/Helper";
import { useSelector } from "react-redux";

const WithdrawHistoryTable = () => {
  const { token } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const location = useSelector(
    (state) => state?.globalState?.teacher_details?.data?.location,
  );
  const getLocation = location
    ? location
        .split(",")
        .pop()
        .trim()
    : "";
  const Location = getLocation ? getLocation : "India";
  const isIndia = Location === "India";
  const PAGE_SIZE = 12;

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const fetchWidrawalHistory = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get("/withdrawals/history/", {
        params: {
          page,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      if (response.status === 200 || response.status === 201) {
        const responseData = response?.data;

        setData(responseData?.data || []);
        setNextUrl(responseData?.next || null);
        setPrevUrl(responseData?.previous || null);
        const count = responseData?.count || 0;
        setTotalPages(Math.ceil(count / PAGE_SIZE));
      } else {
        console.error(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWidrawalHistory(currentPage);
  }, [currentPage]);
  return (
    <>
      <div className="!hidden lg:!block">
        <table className="revenue-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Withdrawal Amount</th>
              <th>Receipt No.</th>
              <th>Payout Status</th>
              <th>Receipt</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td
                  colSpan={5}
                  style={{ textAlign: "center", padding: "12px" }}
                >
                  Loading withdrawal history...
                </td>
              </tr>
            )}
            {!loading && data.length === 0 && (
              <tr>
                <td
                  colSpan={5}
                  style={{ textAlign: "center", padding: "12px" }}
                >
                  No withdrawal history found.
                </td>
              </tr>
            )}

            {data.map((d) => {
              return (
                <tr>
                  <td className="datafield">
                    {/* {`${
                      Helper.formatDateTimeByLocation(d?.date, Location).date
                    } ${
                      Helper.formatDateTimeByLocation(d?.date, Location).time
                    }`} */}
                    {d?.local_date} {d?.local_time}
                  </td>{" "}
                  <td className="font-medium">
                    {d?.currency_symbol || ""}
                    {new Intl.NumberFormat("en-IN").format(
                      d?.withdrawal_amount,
                    )}
                  </td>
                  <td className="font-medium">{d?.receipt_no}</td>
                  <td>
                    <span className={`status ${d?.payout_status?.code}`}>
                      {d?.payout_status?.label}
                    </span>
                  </td>
                  {d.download_receipt !== null ? (
                    <td className="receipt-link">
                      <a
                        href={d.download_receipt}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={download_Graph}
                          alt="download logo"
                          fill="#0068FF"
                          style={{
                            filter:
                              "brightness(0) saturate(100%) invert(32%) sepia(99%) saturate(2733%) hue-rotate(205deg)",
                          }}
                        />{" "}
                        Download Receipt
                      </a>
                    </td>
                  ) : (
                    <td className="receipt-dash">-</td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="!block lg:!hidden">
        {loading && (
          <div className="flex items-center justify-center py-10">
            <p className="text-sm text-gray-800">
              Loading withdrawal history...
            </p>
          </div>
        )}
        {!loading && data.length === 0 && (
          <div className="flex items-center justify-center py-10">
            <p className="text-sm text-gray-800">
              No withdrawal history found.
            </p>
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {data.map((d, index) => (
            <div
              key={d?.receipt_no || index}
              className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3"
            >
              <div className="grid grid-cols-2 gap-y-5 gap-x-4">
                {/* Date */}
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-bold text-gray-800">
                    Date :
                  </span>
                  <span className="text-sm text-gray-500">
                    {/* {Helper.formatDateTimeByLocation(d?.date, Location).date}{" "}
                        {Helper.formatDateTimeByLocation(d?.date, Location).time} */}
                    {d?.local_date} {d?.local_time}
                  </span>
                </div>

                {/* Withdrawal Amount */}
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-bold text-gray-800">
                    Withdrawal Amount :
                  </span>
                  <span className="text-sm text-gray-500">
                    {d?.currency_symbol || ""}
                    {new Intl.NumberFormat("en-IN").format(
                      d?.withdrawal_amount,
                    )}
                  </span>
                </div>

                {/* Receipt No */}
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-bold text-gray-800">
                    Receipt No :
                  </span>
                  <span className="text-sm text-gray-500 truncate">
                    {d?.receipt_no || "—"}
                  </span>
                </div>

                {/* Payout Status */}
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-bold text-gray-800">
                    Payout Status :
                  </span>
                  <span className={`status ${d?.payout_status?.code} w-fit`}>
                    {d?.payout_status?.label}
                  </span>
                </div>
              </div>

              {/* Download */}
              {d.download_receipt && (
                <div className="flex justify-center mt-5">
                  <a
                    href={d.download_receipt}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-[#0068FF] text-sm font-medium"
                  >
                    <img
                      src={download_Graph}
                      alt="download"
                      className="w-4 h-4"
                      style={{
                        filter:
                          "brightness(0) saturate(100%) invert(32%) sepia(99%) saturate(2733%) hue-rotate(205deg)",
                      }}
                    />
                    Download Receipt
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {totalPages > 1 && (
        <div className="pagination-revenue">
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              siblingCount={1}
              boundaryCount={1}
            />
          </Grid>
        </div>
      )}
    </>
  );
};

export default WithdrawHistoryTable;